import { models } from '@/resources/lang/ja/models'
import { views } from '@/resources/lang/ja/views'
import { system } from '@/resources/lang/ja/system'

export const index = {
  models: models,
  views: views,
  system: system,
}
